import { RootState } from 'editor/src/store/index';

const getFirstSpreadWithGridIndex = (state: RootState) =>
  state.design.designData?.spreads.findIndex((spread) =>
    spread.pages[0].groups.media?.find((media) => media.type === 'grid'),
  ) ?? -1;

export default getFirstSpreadWithGridIndex;
